import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing, theme} from '@logistics-frontend/blocks/theme/theme'
import {cssTheme} from '@logistics-frontend/blocks/v2'

export const classes = {
  coupon: css`
    border-bottom: 1px solid ${theme.palette.grey[300]};
    padding: ${spacing(1, 0)};
  `,
  couponTitle: css`
    display: flex;
    font-size: 18px;
  `,
  couponDescription: css`
    font-size: ${cssTheme.fonts.sizes.caption2};
    color: ${theme.palette.grey.A200};
  `,
  couponError: css`
    font-size: ${cssTheme.fonts.sizes.caption2};
    color: ${theme.palette.error.main};
    text-align: end;
  `,
  smallRemoveButton: css`
    height: ${spacing(2.5)};
    width: ${spacing(2.5)};
    line-height: 0;
    padding: 0;
    font-weight: ${cssTheme.fonts.weights.bold};
    font-size: ${cssTheme.fonts.sizes.body2};
    cursor: pointer;
  `,
}
